var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info.type === 'phrase')?_c('div',{staticClass:"phrase"},[_c('div',{staticClass:"phrase-text",domProps:{"innerHTML":_vm._s(_vm.info.description)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }